import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { CommunicationsService } from "../../../../auth/service/communications.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import moment from "moment";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-navbar-notification",
  templateUrl: "./navbar-notification.component.html",
  styleUrls: ["./navbar-notification.component.scss"],
})
export class NavbarNotificationComponent implements OnInit {
  @ViewChild("notificationUL") notificationUL: ElementRef;

  @ViewChild("notificationLI") notificationLI: ElementRef;

  public me: ICurrentUser;

  public notificationsLoaded: boolean = false;

  public today: any = moment().format("YYYY-MM-DD HH:mm:ss");

  constructor(
    public _communicationService: CommunicationsService,
    public _authenticationService: AuthenticationService,
    public router: Router,
    public _utilService: UtilsService,
    public _domSanitizer: DomSanitizer,
  ) {
    this.me = this._authenticationService.getCurrentUser();
  }

  async ngOnInit() {
    await this.loadNotifications();
  }

  async loadNotifications() {
    await this._communicationService.getMine().then(() => {
      this.notificationsLoaded = true;
    });
  }

  transform(html: string): SafeHtml {
    return this._domSanitizer.bypassSecurityTrustHtml(html);
  }

  async openNotification(id: Array<number>) {
    this._utilService.showLoading();
    const selectedNotifcation = this._communicationService.myNotifications.find((item: any) => item.id === id);
    this.router.navigate(["dashboard/notifications"], { queryParams: { id } }).then(async () => {
      await this.loadNotifications();
      if (!selectedNotifcation.read) {
        await this._communicationService.setRead([id]);
      }
    });
    this.notificationUL.nativeElement.classList.remove("show");
    this.notificationLI.nativeElement.classList.remove("show");

    this._utilService.hideLoading();
  }

  async goToNotifications() {
    this.notificationUL.nativeElement.classList.remove("show");
    this.notificationLI.nativeElement.classList.remove("show");
    await this.router.navigateByUrl("/dashboard/notifications");
  }
}
